
import { Component, Vue } from 'vue-property-decorator';
import { getFaultTypeStatistics, exportFaultTypeStatistics } from '@/api/statisticsFaultType';
import { UserModule } from '../../store/modules/user';
// import DialogCustomer from "@/components/CustomerDialog/levelByLevel.vue";
import FaultDialog from '@/components/FaultDialog/index.vue';
import {
  checkPermissionCompany,
  checkPermissionRole,
} from "@/utils/permission";
import { Type } from "@/types/permissionType";

@Component({
  name: 'StatisticsCustomer',
  components: {
    FaultDialog
  }
})
export default class extends Vue {
  private formSearch:any = {
    name: '',
    timePeriods: '',
    fualtType: {}
  }
  // private pickerOptions:any = {
  //   disabledDate(time: any) {
  //     let y = new Date().getFullYear();
  //     let m = new Date().getMonth();
  //     let d = new Date().getDate();
  //     return time.getTime() >= new Date(y, m, d, 0, 0, 0);
  //   }
  // }
  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); //
        const end = new Date(today); 
        const start = new Date(today); 
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
     const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }

  private faultVisible  = false
  private faultType = 2;
  private pFaultTypeArr = [{id:0,name:"顶级"}]
  // private pFaultTypeId = 0;
  private pFaultTypeLevel = 1;
  //计算属性
  get faultTypeName(){
    return  this.faultType == 1 ? "故障类型" : "故障现象";
  }
  get faultTypeNamePlaceHolder(){
    return  "请选择"+this.faultTypeName;
  }
 
  private selectFault() {
    this.faultVisible  = true;
  }
  private faultDialogClose(val: boolean) {
    this.faultVisible  = val;
  }

  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }

  private handleCurrentChange(page:number) {
    this.pagination.currentPage = page;
    this.getList();
  }

  private handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getList();
  }

  private loading = false
  private tableData: any = [];
  private titleData: any ={};

  private sortField = '';
  private sortRule = '';

  private handleSortChange({ prop, order }: any) {
    if (order) {
      // 订单占比后端为计算字段，排序时使用总订单数
      this.sortField = prop === 'orderRatio' ? 'totalCount' : prop;
      // sort_rule: 1 倒序(desc) 2 正序(asc)
      this.sortRule = order === 'descending' ? '1' : '2';
    } else {
      this.sortField = '';
      this.sortRule = '';
    }
    this.pagination.currentPage = 1;
    this.getList();
  }

  private selectedData: string[] = [];
  private handleSelected(val:any[]) {
    this.selectedData = val;
  }
  // 导出Excel
  private handleExport() {
    const pFaultTypeId = this.pFaultTypeArr[this.pFaultTypeArr.length-1].id;
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName,
      level :this.pFaultTypeLevel,
      p_fault_type_id: pFaultTypeId,
      type:this.faultType,
      time_type: 5,
    };
    // let customerCompanyIds = '';
    // if (this.selectedData && this.selectedData.length > 0) {
    //   for (let i of this.selectedData) {
    //     let item:any = i;
    //     let customerId = '';
    //     if (parseInt(item.customer_company_id) === 0 || !item.customer_company_id) {
    //       customerId = 'p' + item.user_id;
    //     } else {
    //       customerId = item.customer_company_id;
    //     }
    //     customerCompanyIds = customerCompanyIds + customerId + ',';
    //   }
    //   params.customer_ids = customerCompanyIds.substring(0, customerCompanyIds.length - 1);
    // }
    // if (this.formSearch.customer && this.formSearch.customer.customer_company_id) {
    //   params.customer_company_id = this.formSearch.customer.customer_company_id;
    // }
    if (this.formSearch.timePeriods && this.formSearch.timePeriods.length === 2) {
      params.start_time = parseInt(this.formSearch.timePeriods[0]) / 1000;
      params.end_time = parseInt(this.formSearch.timePeriods[1]) / 1000;
    }
    // if (this.branchId) {
    //   params.branch_id = this.branchId;
    // }
    exportFaultTypeStatistics(params).then(res => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  // private settingColumnItem = false
  // private columnItemData: any = {
  //   all: { name: '全选', value: '0', checked: true },
  //   customer: { name: '客户', value: '1', checked: true },
  //   orderall: { name: '总订单', value: '2', checked: true },
  //   orderallBranch: { name: '分公司总订单', value: '3', checked: true },
  //   finished: { name: '已完成', value: '4', checked: true },
  //   closed: { name: '已关闭', value: '5', checked: true },
  //   operation: { name: '操作', value: '15', checked: true }
  // }
  // private showHideColumn() {
  //   this.settingColumnItem = !this.settingColumnItem;
  // }
  // private setColumnItem() {
  //   this.settingColumnItem = true;
  // }

  created() {
    // let body = document.documentElement || document.body;
    // body.addEventListener('click', (e: any) => {
    //   if (e.target.id !== 'getColumnItemBtn') {
    //     this.settingColumnItem = false;
    //   }
    // }, false);
    // this.faultType = this.$route.query && this.$route.query.faultType ? parseInt(this.$route.query.faultType as string) : 2 ;
    // this.pFaultTypeId = this.$route.query && this.$route.query.pFaultTypeId ? parseInt(this.$route.query.pFaultTypeId as string) : 1 ;
        //获取路由参数
    if("/Statistics/faultType"==this.$route.path){
      this.faultType =1;
      // this.pFaultTypeId = 0;
      this.pFaultTypeLevel = 1;
    }else{
      this.faultType =2;
      // this.pFaultTypeId = 0;
      this.pFaultTypeLevel = 1;
    }
    this.pFaultTypeArr = [{id:0,name:"顶级"}];

    this.initTimePeriods();  

    this.getList();
  }
  private initTimePeriods(){
    let dataStrStart = new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + '1 00:00:00';
    let dataStrEnd = new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getDate() + ' 23:59:59';
    this.formSearch.timePeriods = [ new Date(dataStrStart).getTime(), new Date(dataStrEnd).getTime() ];
  }
  //
  private faultSelected(fualtType:any) {
    this.formSearch.fualtType = fualtType;
  }
  private getList() {
    const pFaultTypeId = this.pFaultTypeArr[this.pFaultTypeArr.length-1].id;
    let orderParams:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      level :this.pFaultTypeLevel,
      p_fault_type_id: pFaultTypeId,
      type:this.faultType,
      time_type: 5,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize
    };

    if (this.sortField) {
      orderParams.sort_field = this.sortField;
      orderParams.sort_rule = this.sortRule;
    }

    if (this.formSearch.timePeriods && this.formSearch.timePeriods.length === 2) {
      orderParams.start_time = this.formSearch.timePeriods[0] / 1000;
      orderParams.end_time = this.formSearch.timePeriods[1] / 1000;
    }


    // if (this.formSearch.customer && this.formSearch.customer.customer_company_id) {
    //   orderParams.customer_company_id = this.formSearch.customer.customer_company_id;
    // }
    // if (this.formSearch.customer && this.formSearch.customer.customer_user_id) {
    //   orderParams.customer_user_id = this.formSearch.customer.customer_user_id;
    // }
    // if (this.formSearch.name) {
    //   orderParams.name = this.formSearch.name;
    // }
    // if (this.branchId) {
    //   orderParams.branch_id = this.branchId;
    // }

    this.loading = true;
    getFaultTypeStatistics(orderParams).then(res => {
      if (res && res.data && res.data.list ) {

        this.tableData = res.data.list;
        this.titleData = res.data.titleDes;

        this.pagination.total = parseInt(res.data.count);
        this.pagination.pageSize = parseInt(res.data.page_size);

      } else {

        this.pagination.total = 0;
        this.titleData = res.data.titleDes;
        this.tableData = [];
        
      }
      this.loading = false;
    }).catch(err => {
      if (!err.data) {
        this.tableData = [];
        this.loading = false;
      }
      // this.showErrorMsg(err.msg);
    }
    );
  }

  private handleDetail(row: any) {
    this.$router.push({
      path: '/Statistics/customerDetail',
      query: { 'customer': JSON.stringify(row) }
    });
  }

  private handleBack(){
    this.pFaultTypeLevel = this.pFaultTypeLevel - 1;
    this.pFaultTypeArr.pop();

    this.getList();
  }

  private handleBranch(row:any) {
    // this.branchId = row.customer_company_id;

    this.pFaultTypeLevel = this.pFaultTypeLevel + 1;
    if(this.pFaultTypeLevel == 2){
      // this.pFaultTypeId =  row.p_fault_type_id
      this.pFaultTypeArr.push({id:row.p_fault_type_id,name:row.name});
    }else if(this.pFaultTypeLevel == 3){
      // this.pFaultTypeId =  row.fault_type_id
      this.pFaultTypeArr.push({id:row.fault_type_id,name:row.name});
    }
    this.pagination.currentPage = 1;
    this.getList();
  }
  private handleCellClick(row: any, v: string) {
    if(!checkPermissionRole(
        UserModule.getCompanyId,
        Type.ORDER_LOOK_COM
    )){
      return;
    }
    //v在数组中，点击跳转到订单详情页
    if(!['completeCount','closeCount','totalCount'].includes(v)){
      return;
    }
    if(parseInt(row[v])<= 0){
      return;
    }
    let id = '';
    let order_service_finish_state = '';
    let finish_start_time = 0;
    let finish_end_time = 0;
    let fault_id = '';
    let phenomenon_id = '';
    if (this.formSearch.timePeriods && this.formSearch.timePeriods.length === 2) {
      finish_start_time = this.formSearch.timePeriods[0] / 1000;
      finish_end_time = this.formSearch.timePeriods[1] / 1000;
    }
    if (this.pFaultTypeLevel == 1) {
      id = row.p_fault_type_id;
    } else if(this.pFaultTypeLevel == 2){
      id = row.fault_type_id;
    }else{
      id = row.c_fault_type_id;
    }
    if (this.faultType == 1) {
      fault_id = id;
    }else{
      phenomenon_id = id;
    }
    switch (v) {
      case 'completeCount':
        order_service_finish_state = '1';
        break;
      case 'closeCount':
         order_service_finish_state = '2';
        break;
      case 'totalCount':
        break;
      default:
        break;
    }
    const routeData = this.$router.resolve({
      path: '/OrderServicer/completed',
      query: { 
        'fault_id': fault_id ,
        'phenomenon_id':phenomenon_id,
        'order_service_finish_state': order_service_finish_state,
        'finish_start_time': finish_start_time+"",
        'finish_end_time': finish_end_time+""
      }
    });
    window.open(routeData.href, '_blank');

  }

  private handleSearch() {
    this.pagination.currentPage = 1;
    this.getList();
  }

  private handleClear() {
    this.formSearch = {
      name: '',
      timePeriods:[],
      // customer: {}
    };
    // this.initTimePeriods();  
    
    this.pagination.currentPage = 1;
    this.pagination.total = 0;
    this.getList();
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  
}
